/**
 * Created by mykurisu on 2017/10/30.
 */
import React from 'react'
import {connect} from 'react-redux'
import {ActionSheet, Dialog, Toast} from 'react-weui'
import axios from 'axios'
import { getJsonFromUrl, renderMoney } from '../../utils'
import {WKInfiniteScroll, WKSkeletonScreen} from '../../components/wk'
import {isPC, renderCouponMoney} from '../../utils/index'
import yhq from '../../images/yhq.png'
import yhqDeep from '../../images/yhq-deep.png'

import side from '../../images/coupon/coupon__side.png'
import redpacketSmImg from '../../images/coupon/redpacket-sm.png'
import '../../css/common/CouponBar.css'


class CouponItem extends React.Component {

    renderScope() {
        const {content} = this.props;
        const {coupon} = content;
        // console.log(coupon)
        switch (content.coupon.scope){
            case 'weike':
                return '点击券面查看';
            case 'liveroom':
                if (coupon.threshold_enabled) {
                    return `店铺内满￥${renderMoney(coupon.threshold_price)}可用`
                }
                return '店铺通用';
            case 'lecture':
                return `课程【${coupon.object_name}】`;
            case 'channel':
                return `专栏【${coupon.object_name}】`;
        }
    }

    isNoSuit () {
        const type = this.props.type
        const money = this.props.money
        const { threshold_enabled, threshold_price } = this.props.content.coupon
        if (!threshold_enabled) return false
        if (type !== 'liveroom') return false

        return threshold_price > money
    }

    render() {
        const {content} = this.props;
        const {coupon} = content;
        if (this.isNoSuit()) return null
        return (
            <div className="list__item">
                <div className="item__left">
                    <div className="left__side">
                        <img src={side} alt=""/>
                    </div>
                    <div className="left__content">
                        <div className="content__price">
                            <span>￥</span>
                            <span>{renderCouponMoney(coupon.price)}</span>
                        </div>
                        <div
                            onClick={content.coupon_status === 'active' ? null : () => this.props.handleGetTheCoupon(coupon.code, coupon)}
                            className={content.coupon_status === 'active' ? 'content__btn-active' : 'content__btn'}>
                            {content.coupon_status === 'active' ? '已领取' : '立即领取'}
                        </div>
                    </div>
                </div>
                <div className="item__right">
                    <div className="right__title">
                        {content.coupon.scope === 'weike' ? content.coupon.title : coupon.coupon_name}
                    </div>
                    {content.coupon.scope === 'luck_coupon' ?
                        <div className="right__message">
                            <p>
                                <span>全场通用</span>
                                <span></span>
                            </p>
                            <p>
                                <span>适用范围：</span>
                                <span>仅限APP</span>
                            </p>
                            {coupon.deadline &&
                            <p>
                                <span>有效期至：</span>
                                <span>{coupon.deadline}</span>
                            </p>
                            }
                        </div>
                        :
                        <div className="right__message">
                            {content.coupon.scope === 'weike' ?
                                <p>
                                    <span>平台优惠券</span>
                                    <span></span>
                                </p>
                                :
                                <p>
                                    <span>店铺：</span>
                                    <span>{content.coupon.scope === 'weike_app' ? 'APP优惠券' : this.props.liveroomName}</span>
                                </p>
                            }
                            <p>
                                <span>适用范围：</span>
                                <span>{this.renderScope()}</span>
                            </p>
                            {coupon.deadline &&
                            <p>
                                <span>有效期至：</span>
                                <span>{coupon.deadline}</span>
                            </p>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}


class CouponBar extends React.Component {

    constructor() {
        super();
        this.state = {
            couponSheetShow: false,
            actions: [
                {
                    label: 'Cancel',
                    onClick: () => {}
                }
            ],
            list: null,
            has_more: null,
            next_offset: null,
            loading: false,
            liveroomName: '',
            dialogShow: false,
            dialogMsg: null,
            addToast: false,

            firstScrollY: 0,
            scrollY: 0,
            maxHeight: 0,
        }
        this.isNewCoupon = getJsonFromUrl().is_new_coupon == 1
    }

    componentDidMount() {
        const money = this.getMoney(this.props.type)
        axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/active_coupons`, {
            params: {
                money: money
            }
        })
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        list: res.data.data.coupons,
                        liveroomName: res.data.data.liveroom_name,
                        has_more: res.data.data.has_more,
                        next_offset: res.data.data.next_offset
                    });
                }
            })
    }

    handleSheetShow() {
        const money = this.getMoney(this.props.type)
        if (this.state.list && this.state.list.length === 0){
            this.handleKurisu()
        }else {
            this.setState({
                couponSheetShow: true
            });
            if (!this.state.list){
                axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/active_coupons`, {
                    params: {
                        money: money
                    }
                })
                    .then(res => {
                        if (res.data.code === 0) {
                            this.setState({
                                list: res.data.data.coupons,
                                liveroomName: res.data.data.liveroom_name,
                                has_more: res.data.data.has_more,
                                next_offset: res.data.data.next_offset
                            }, () => {
                                this.setState({
                                    maxHeight: document.querySelector('#wrap').offsetHeight || 0
                                })
                            });
                            /*if (!isPC()){
                             this.scrollArea && this.scrollArea.addEventListener('touchstart', (e) => this.listStart(e), false);
                             this.scrollArea && this.scrollArea.addEventListener('touchmove', (e) => this.listMove(e), false);
                             }*/
                        }
                    })
            }
        }
    }

    listStart(e) {
        e.preventDefault();
        let touch = e.touches[0];
        this.setState({
            firstScrollY: touch.pageY
        });
    }

    listMove(e) {
        e.preventDefault();
        let touch = e.touches[0];
        let y = touch.pageY - this.state.firstScrollY; //滑动的距离

        this.setState({
            firstScrollY: touch.pageY
        }, () => {
            /*if (this.state.scrollY < -(this.state.maxHeight - 300)){
                this.setState({
                    scrollY: -(this.state.maxHeight - 300)
                });
            }else {
                this.setState({
                    scrollY: (this.state.scrollY + y) >= 0 ? 0 : this.state.scrollY + y
                });
            }*/
            if (y >= 0){
                this.setState({
                    scrollY: (this.state.scrollY + y) >= 0 ? 0 : this.state.scrollY + y
                });
            }else {
                this.setState({
                    scrollY: (this.state.scrollY + y) <= -(this.state.maxHeight - 280) ? -(this.state.maxHeight - 280) : this.state.scrollY + y
                });
            }
        })

    }


    renderCouponList(object) {
        const money = this.getMoney(this.props.type)
        return (
            <div className="couponbar__list">
                <div className="couponbar__list-title">
                    优惠券
                </div>
                {this.state.list ?
                    <div id="wrap" style={{overflowY: 'scroll', maxHeight: '245px'}}>
                        {this.state.list.map((item) => <CouponItem
                            type={this.props.type}
                            key={item.coupon.id}
                            content={item}
                            money={money}
                            object={object}
                            liveroomName={this.state.liveroomName}
                            handleGetTheCoupon={(code, coupon) => this.handleGetTheCoupon(code, coupon)}
                        />)}
                    </div>
                :
                    <WKSkeletonScreen num={3}/>}
            </div>
        )
    }

    getMoney (type) {
        if (type === 'lecture') {
            return this.props.lecture.lecture.limit_money && this.props.lecture.lecture.limit_money.money || this.props.lecture.lecture.money
        }
        if (type === 'channel') {
            return this.props.channel.channel.promoprice && this.props.channel.channel.promoprice.price || this.props.channel.channel.money
        }
        if (type === 'liveroom') {
            return this.props.vip_info && this.props.vip_info.vip_fee
        }
    }

    handleGetTheCoupon(code, coupon) {
        const money = this.getMoney(this.props.type)
        let data = new FormData();
        let pathname = window.location.pathname;
        if (/lecture/.test(pathname)){
            data.append('lecture_id', this.props.target_id);
        }else if (/channel/.test(pathname)){
            data.append('channel_id', this.props.target_id);
        }else if (/liveroom/.test(pathname)){
            data.append('liveroom_id', this.props.target_id);
        }
        data.append('code', code + '');
        data.append('scope', this.props.type);
        data.append('liveroom_id', coupon.liveroom_id);

        axios.post(`/api/coupon/accept`, data)
            .then(res => {
                if (res.data.code === 0) {
                    axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/active_coupons`, {
                        params: {
                            money: money
                        }
                    })
                        .then(res => {
                            if (res.data.code === 0) {
                                this.setState({
                                    list: res.data.data.coupons,
                                    liveroomName: res.data.data.liveroom_name,
                                    has_more: res.data.data.has_more,
                                    next_offset: res.data.data.next_offset,
                                });
                                this.handleShowToast();
                                axios.get(`/api/coupon/${this.props.type}/${this.props.target_id}/receiver_coupons`, {
                                    params: {
                                        money: money
                                    }
                                })
                                    .then(res => {
                                        if (res.data.code === 0) {
                                            let data = res.data.data.coupons;
                                            let canuse = data.find((item) => {
                                                return item.coupon_status === 'active' && item.coupon.scope !== 'luck_coupon'
                                            });
                                            if (canuse){
                                                this.props.dispatch({
                                                    type: 'NEW_COUPON_DATA',
                                                    payload: canuse.coupon
                                                });

                                                this.props.dispatch({
                                                    type: 'COUPON_USE_BUY'
                                                })
                                            }
                                        }
                                    })
                            }
                        })
                }else {
                    this.setState({
                        dialogShow: true,
                        dialogMsg: res.data.msg,
                        couponSheetShow: false
                    })
                }
            })
    }

    handleShowToast() {
        this.setState({addToast: true});

        this.toastTimer = setTimeout(()=> {
            this.setState({addToast: false});
        }, 1000);
    }

    handleKurisu() {
        this.setState({
            dialogShow: true,
            dialogMsg: '来晚了，优惠券被领完了'
        })
    }

    componentWillUnmount() {
        this.toastTimer && clearTimeout(this.toastTimer)
    }

    render() {
        const {type, lecture, channel} = this.props
        const object = type === 'channel' ? channel.channel : lecture.lecture
        const isNewCoupon = type === 'channel' && this.isNewCoupon
        return (
            <div className={`couponbar`} style={{marginTop: this.props.shouldTop ?  '-10px' : '0'}}>

                <Dialog type="ios" title={'温馨提示'} buttons={
                    [
                        {
                            label: '确定',
                            onClick: () => {
                                this.setState({
                                    dialogShow: false
                                })
                            }
                        }
                    ]
                } show={this.state.dialogShow}>
                    {this.state.dialogMsg}
                </Dialog>

                <ActionSheet
                    menus={[{label: this.renderCouponList(object)}]}
                    show={this.state.couponSheetShow}
                    type="ios"
                    onRequestClose={e=>this.setState({couponSheetShow: false})}
                />

                <div className="couponbar__shownbar" onClick={() => this.handleSheetShow()}>
                    <div className="shownbar__left">
                        <img src={isNewCoupon ? redpacketSmImg : yhqDeep} alt=""/> {isNewCoupon ? '红包' : '优惠券'} 
                    </div>
                    <div className="shownbar__right"></div>
                </div>

                <Toast icon="success-no-circle" show={this.state.addToast}>领取成功</Toast>

            </div>
        )
    }
}


export default connect(state => ({
    channel: state.channel,
    lecture: state.lecture,
}))(CouponBar)



// WEBPACK FOOTER //
// ./src/components/details/CouponBar.js